<template>
    <v-card>
        <slot>
            <v-card-title>
                {{ title }}
                <v-spacer></v-spacer>
                <search-field v-model="search"></search-field>
                <v-btn
                    v-if="hasAddNewButton"
                    color="primary"
                    dark
                    class="ml-2"
                    @click="addNewItem"
                >
                    Adaugare
                </v-btn>
                <v-dialog
                    v-else
                    v-model="dialog"
                    max-width="500px"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="primary"
                            dark
                            class="ml-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            Adaugare
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col
                                        cols="12"
                                        sm="6"
                                        md="4"
                                    >
                                        <v-text-field
                                            v-model="form.name"
                                            label="Dessert name"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="6"
                                        md="4"
                                    >
                                        <v-text-field
                                            v-model="form.calories"
                                            label="Calories"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="6"
                                        md="4"
                                    >
                                        <v-text-field
                                            v-model="form.fat"
                                            label="Fat (g)"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="6"
                                        md="4"
                                    >
                                        <v-text-field
                                            v-model="form.carbs"
                                            label="Carbs (g)"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="6"
                                        md="4"
                                    >
                                        <v-text-field
                                            v-model="form.protein"
                                            label="Protein (g)"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="close"
                            >
                                Renuntare
                            </v-btn>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="save"
                            >
                                Salveaza
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                        <v-card-title class="headline">Sunteti sigur ca doriti stergerea intrarii?</v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click="closeDelete">Anulare</v-btn>
                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">Confirmare</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-card-title>
        </slot>
        <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="meta.pagination.total"
            :footer-props="footerOptions"
            class="elevation-1"
        >
            <template v-slot:item.actions="{ item }">
                <v-icon
                    v-if="canUpdate(item)"
                    small
                    class="mr-2"
                    @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    v-if="canDelete(item)"
                    small
                    @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:no-data>
                <p class="my-2">Nu am gasit nici un rezultat.</p>
                <v-btn
                    class="my-2"
                    color="primary"
                    @click="reset"
                >
                    Eliminare filtre
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
    import validationError from "Mixins/validation-error";
    import {Form} from "vform";
    export default {
        mixins: [validationError],
        data: () => ({
            title: 'My Sample title',
            search: '',
            dialog: false,
            dialogDelete: false,
            headers: [],
            items: [],
            meta: {
                pagination: {
                    count: 0,
                    current_page: 0,
                    per_page: 0,
                    total: 0,
                    total_pages: 0
                }
            },
            editedIndex: -1,
            form: new Form({
                name: '',
                calories: 0,
                fat: 0,
                carbs: 0,
                protein: 0,
            }),
            defaultItem: {
                name: '',
                calories: 0,
                fat: 0,
                carbs: 0,
                protein: 0,
            },
            options: {
                groupBy: [],
                groupDesc: [],
                itemsPerPage: 10,
                multiSort: false,
                mustSort: false,
                page: 1,
                sortBy: [],
                sortDesc: []
            },
            footerOptions: {
                itemsPerPageOptions: [10, 25, 50, 100, 250, 500, 1000]
            }
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
            },
            orderBy() {
                let sortValues = Object.keys(this.options.sortBy).map((sortField) => {
                    return this.options.sortDesc[sortField] ?
                        `-${this.options.sortBy[sortField]}` :
                        `${this.options.sortBy[sortField]}`;
                })
                return sortValues.join(',')
            },
            hasAddNewButton()
            {
                return this.$options.methods.addNewItem instanceof Function
            }
        },

        watch: {
            options: {
                handler (newV, oldV) {
                    if(!this._.isEqual(newV, oldV)) {
                        this.initialize()
                    }
                },
                deep: true,
            },
            search: {
                handler () {
                    this.initialize()
                }
            },
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
        },

        methods: {
            initialize () {
                console.warn('Initialize not implemented');
            },

            reset() {
                this.search = ''
                this.options = {
                    groupBy: [],
                    groupDesc: [],
                    itemsPerPage: 10,
                    multiSort: false,
                    mustSort: false,
                    page: 1,
                    sortBy: [],
                    sortDesc: []
                }
            },

            editItem (item) {
                this.editedIndex = this.items.indexOf(item)
                this.form = new Form(Object.assign({}, item))
                this.dialog = true
            },

            deleteItem (item) {
                this.editedIndex = this.items.indexOf(item)
                this.form = new Form(Object.assign({}, item))
                this.dialogDelete = true
            },

            deleteItemConfirm () {
                this.items.splice(this.editedIndex, 1)
                this.closeDelete()
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                    this.form = new Form(Object.assign({}, this.defaultItem))
                    this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.form = new Form(Object.assign({}, this.defaultItem))
                    this.editedIndex = -1
                })
            },

            save () {
                if (this.editedIndex > -1) {
                    Object.assign(this.items[this.editedIndex], this.form)
                } else {
                    this.items.push(this.form)
                }
                this.close()
            },
            canUpdate(item) {
                return true;
            },
            canDelete(item) {
                return true;
            }
        },
    };
</script>
